import { render } from "./ProduceVue.vue?vue&type=template&id=30f09512"
import script from "./ProduceVue.vue?vue&type=script&lang=js"
export * from "./ProduceVue.vue?vue&type=script&lang=js"

import "./ProduceVue.vue?vue&type=style&index=0&id=30f09512&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__